import React from "react";
import { motion } from "framer-motion";

// Variants for the footer elements
const footerVariant = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, staggerChildren: 0.2 },
  },
};

const itemVariant = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
};

const iconVariant = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.3 } },
};

const Footer = () => {
  return (
    <motion.footer
      initial="hidden"
      animate="visible"
      variants={footerVariant}
      className="bg-white text-black dark:text-white dark:bg-black pt-20 px-4 lg:px-16"
    >
      <div className="mx-auto w-full max-w-screen-xl">
        <motion.div variants={itemVariant} className="mb-8 px-4">
          <h2 className="mb-4 text-xl font-lota font-semibold text-black dark:text-white">
            Address
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
            <motion.address
              variants={itemVariant}
              className="bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-4 rounded-lg"
            >
              <div className="flex items-start gap-3">
                <svg
                  className="w-5 h-5 text-indigo-600 dark:text-indigo-400 mt-1"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M12 2C8.686 2 6 4.686 6 8c0 5.25 6 12 6 12s6-6.75 6-12c0-3.314-2.686-6-6-6zm0 8.5A2.5 2.5 0 1 1 12 5.5a2.5 2.5 0 0 1 0 5z" />
                </svg>
                <div>
                  <h3 className="text-sm font-semibold text-black dark:text-white">
                    Abuja head office
                  </h3>
                  <p className="text-[15px] text-gray-700 dark:text-gray-300 mt-1">
                    No 30 Anthony Enohoro
                  </p>
                </div>
              </div>
            </motion.address>

            <motion.address
              variants={itemVariant}
              className="bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-4 rounded-lg"
            >
              <div className="flex items-start gap-3">
                <svg
                  className="w-5 h-5 text-indigo-600 dark:text-indigo-400 mt-1"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M12 2C8.686 2 6 4.686 6 8c0 5.25 6 12 6 12s6-6.75 6-12c0-3.314-2.686-6-6-6zm0 8.5A2.5 2.5 0 1 1 12 5.5a2.5 2.5 0 0 1 0 5z" />
                </svg>
                <div>
                  <h3 className="text-sm font-semibold text-black dark:text-white">
                    Lagos branch
                  </h3>
                  <p className="text-[15px] text-gray-700 dark:text-gray-300 mt-1">
                    11A Pelewura Way, Apapa, First floor
                  </p>
                </div>
              </div>
            </motion.address>

            <motion.address
              variants={itemVariant}
              className="bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-4 rounded-lg"
            >
              <div className="flex items-start gap-3">
                <svg
                  className="w-5 h-5 text-indigo-600 dark:text-indigo-400 mt-1"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M12 2C8.686 2 6 4.686 6 8c0 5.25 6 12 6 12s6-6.75 6-12c0-3.314-2.686-6-6-6zm0 8.5A2.5 2.5 0 1 1 12 5.5a2.5 2.5 0 0 1 0 5z" />
                </svg>
                <div>
                  <h3 className="text-sm font-semibold text-black dark:text-white">
                    Kebbi branch
                  </h3>
                  <p className="text-[15px] text-gray-700 dark:text-gray-300 mt-1">
                    Ahmadu Bello way, close to Bindawa, beside Kabir Art, First
                    floor
                  </p>
                </div>
              </div>
            </motion.address>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 gap-8 px-4 py-6 lg:py-8 md:grid-cols-2 lg:grid-cols-4">
          <motion.div variants={itemVariant}>
            <h2 className="mb-6 text-xl font-lota font-semibold text-black dark:text-white">
              Products
            </h2>
            <ul className="text-black dark:text-white text-[15px] font-lota font-semibold">
              <motion.li className="mb-4" variants={itemVariant}>
                <a href="/" className="hover:underline">
                  About
                </a>
              </motion.li>
              <motion.li className="mb-4" variants={itemVariant}>
                <a href="/" className="hover:underline">
                  Careers
                </a>
              </motion.li>
              <motion.li className="mb-4" variants={itemVariant}>
                <a href="/" className="hover:underline">
                  Brand Center
                </a>
              </motion.li>
              <motion.li className="mb-4" variants={itemVariant}>
                <a href="/" className="hover:underline">
                  Blog
                </a>
              </motion.li>
            </ul>
          </motion.div>

          <motion.div variants={itemVariant}>
            <h2 className="mb-6 text-xl font-lota font-semibold text-black dark:text-white">
              Business Type
            </h2>
            <ul className="text-black dark:text-white text-[15px] font-lota font-semibold">
              <motion.li className="mb-4" variants={itemVariant}>
                <a
                  href="https://www.linkedin.com/company/vmonie-technologies/"
                  className="hover:underline"
                >
                  LinkedIn
                </a>
              </motion.li>
              <motion.li className="mb-4" variants={itemVariant}>
                <a
                  href="https://x.com/vmonie_ng?s=09"
                  className="hover:underline"
                >
                  X (Twitter)
                </a>
              </motion.li>
              <motion.li className="mb-4" variants={itemVariant}>
                <a
                  href="https://www.instagram.com/v_monie.ng?igsh=MTF2bXgyYzlyZ2x6Zg=="
                  className="hover:underline"
                >
                  Instagram
                </a>
              </motion.li>
              <motion.li className="mb-4" variants={itemVariant}>
                <a
                  href="mailto:sales@vmonieweb.com"
                  className="hover:underline"
                >
                  Contact Us
                </a>
              </motion.li>
            </ul>
          </motion.div>

          <motion.div variants={itemVariant}>
            <h2 className="mb-6 text-xl font-lota font-semibold text-black dark:text-white">
              Resources
            </h2>
            <ul className="text-black dark:text-white text-[15px] font-lota font-semibold">
              <motion.li className="mb-4" variants={itemVariant}>
                <a href="/" className="hover:underline">
                  Privacy Policy
                </a>
              </motion.li>
              <motion.li className="mb-4" variants={itemVariant}>
                <a href="/" className="hover:underline">
                  Licensing
                </a>
              </motion.li>
              <motion.li className="mb-4" variants={itemVariant}>
                <a href="/" className="hover:underline">
                  Terms & Conditions
                </a>
              </motion.li>
            </ul>
          </motion.div>

          <motion.div variants={itemVariant}>
            <h2 className="mb-6 text-xl font-lota font-semibold text-black dark:text-white">
              Contact
            </h2>
            <ul className="text-black dark:text-white text-[15px] font-lota font-semibold">
              <motion.li className="mb-4" variants={itemVariant}>
                <a href="https://wa.link/meq197" className="underline">
                  WhatsApp: +234 810 747 0376
                </a>
              </motion.li>
              <motion.li className="mb-4" variants={itemVariant}>
                <a href="https://wa.link/ll6leo" className="underline">
                  Phone: +234 915 101 9503
                </a>
              </motion.li>
              <motion.li className="mb-4" variants={itemVariant}>
                <a href="/" className="underline">
                  Email: sales@vmonieweb.com
                </a>
              </motion.li>
              <motion.li className="mb-4" variants={itemVariant}>
                <a href="/" className="underline">
                  Support: support@vmonieweb.com
                </a>
              </motion.li>
            </ul>
          </motion.div>
        </div>

        <div className="px-4 py-6 md:flex md:items-center md:justify-between border-y-[1px] border-gray-300">
          <motion.span
            variants={itemVariant}
            className="text-black dark:text-white text-[15px] font-lota font-medium sm:text-center"
          >
            Nigeria
          </motion.span>

          <div className="flex mt-4 sm:justify-center md:mt-0 space-x-5 rtl:space-x-reverse">
            <motion.a
              href="https://www.instagram.com/v_monie.ng?igsh=MTF2bXgyYzlyZ2x6Zg=="
              className="text-gray-400 hover:text-gray-900 dark:hover:text-white"
              variants={iconVariant}
            >
              {/* Instagram Icon */}
              <svg
                className="w-4 h-4"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.056 1.97.24 2.427.403a4.92 4.92 0 0 1 1.777 1.15 4.92 4.92 0 0 1 1.15 1.777c.163.457.347 1.257.403 2.427.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.056 1.17-.24 1.97-.403 2.427a4.92 4.92 0 0 1-1.15 1.777 4.92 4.92 0 0 1-1.777 1.15c-.457.163-1.257.347-2.427.403-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.056-1.97-.24-2.427-.403a4.92 4.92 0 0 1-1.777-1.15 4.92 4.92 0 0 1-1.15-1.777c-.163-.457-.347-1.257-.403-2.427C2.175 15.747 2.163 15.367 2.163 12s.012-3.584.07-4.85c.056-1.17.24-1.97.403-2.427a4.92 4.92 0 0 1 1.15-1.777A4.92 4.92 0 0 1 5.563 2.636c.457-.163 1.257-.347 2.427-.403C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.736 0 8.332.012 7.052.07 5.773.129 4.872.312 4.042.57a7.06 7.06 0 0 0-2.536 1.03A7.06 7.06 0 0 0 .476 4.136c-.258.83-.441 1.73-.5 3.01C-.012 8.332 0 8.736 0 12s.012 3.668.07 4.948c.059 1.28.242 2.18.5 3.01a7.06 7.06 0 0 0 1.03 2.536 7.06 7.06 0 0 0 1.03 1.03c.83.258 1.73.441 3.01.5C8.332 23.988 8.736 24 12 24s3.668-.012 4.948-.07c1.28-.059 2.18-.242 3.01-.5a7.06 7.06 0 0 0 2.536-1.03 7.06 7.06 0 0 0 1.03-1.03c.258-.83.441-1.73.5-3.01C23.988 15.668 24 15.264 24 12s-.012-3.668-.07-4.948c-.059-1.28-.242-2.18-.5-3.01a7.06 7.06 0 0 0-1.03-2.536 7.06 7.06 0 0 0-1.03-1.03c-.83-.258-1.73-.441-3.01-.5C15.668.012 15.264 0 12 0z" />
                <path d="M12 5.838A6.162 6.162 0 1 0 18.162 12 6.169 6.169 0 0 0 12 5.838zm0 10.162A4 4 0 1 1 16 12a4 4 0 0 1-4 4zM18.406 4.594a1.44 1.44 0 1 1-1.44-1.44 1.44 1.44 0 0 1 1.44 1.44z" />
              </svg>
              <span className="sr-only">Instagram page</span>
            </motion.a>

            <motion.a
              href="https://x.com/vmonie_ng?s=09"
              className="text-gray-400 hover:text-gray-900 dark:hover:text-white"
              variants={iconVariant}
            >
              {/* Twitter Icon */}
              <svg
                className="w-4 h-4"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 17"
              >
                <path
                  fillRule="evenodd"
                  d="M20 1.892a8.178 8.178 0 0 1-2.355.635 4.074 4.074 0 0 0 1.8-2.235 8.344 8.344 0 0 1-2.605.98A4.13 4.13 0 0 0 13.85 0a4.068 4.068 0 0 0-4.1 4.038 4 4 0 0 0 .105.919A11.705 11.705 0 0 1 1.4.734a4.006 4.006 0 0 0 1.268 5.392 4.165 4.165 0 0 1-1.859-.5v.05A4.057 4.057 0 0 0 4.1 9.635a4.19 4.19 0 0 1-1.856.07 4.108 4.108 0 0 0 3.831 2.807A8.36 8.36 0 0 1 0 14.184 11.732 11.732 0 0 0 6.291 16 11.502 11.502 0 0 0 17.964 4.5c0-.177 0-.35-.012-.523A8.143 8.143 0 0 0 20 1.892Z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="sr-only">Twitter page</span>
            </motion.a>

            <motion.a
              href="https://www.linkedin.com/company/vmonie-technologies/"
              className="text-gray-400 hover:text-gray-900 dark:hover:text-white"
              variants={iconVariant}
            >
              {/* LinkedIn Icon */}
              <svg
                className="w-4 h-4"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-9h3v9zm-1.5-10.268c-.966 0-1.75-.784-1.75-1.75S5.534 5.232 6.5 5.232 8.25 6.016 8.25 6.982 6.966 8.732 6.5 8.732zm13.5 10.268h-3v-4.5c0-1.08-.02-2.468-1.5-2.468-1.5 0-1.732 1.172-1.732 2.392v4.576h-3v-9h2.88v1.232h.041c.401-.76 1.379-1.562 2.838-1.562 3.036 0 3.594 1.998 3.594 4.592v5.738z" />
              </svg>
              <span className="sr-only">LinkedIn</span>
            </motion.a>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
